import React from "react";
import classes from "./Footer.module.css";
import "./Footer.css";
function Footer() {
  let year = 2022;
  let new_year = new Date().getFullYear();

  let year_format = "";

  if (year !== new_year) {
    year_format = year + "-" + new_year;
  } else {
    year_format = year;
  }

  return (
    <div className={classes.mainFooter}>
      <div className="container">
        <div className="row">
          <div class="adjustment2">
            <div className="col">
              <img
                className={classes.logo}
                src="https://i.imgur.com/KSH1UR9.png"
                alt=""
              />
              <div className={classes.information2}>
                <ul className="list-unstyled">
                  <div>
                    <li>17817 Leslie Street Unit 30 </li>
                    <li>Newmarket ON L3Y 8C6</li>
                    <li>
                      <br />
                    </li>
                    <li>
                      <a
                        className={classes.info}
                        href="mailto:amplifynewmarket@gmail.com"
                      >
                        amplifynewmarket@gmail.com
                      </a>
                    </li>
                    <li>
                      <br />
                    </li>
                    <li>
                      <a href="tel:905-836-9505">905-836-9505</a>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
          <div className="col">
            <div></div>
          </div>
          <div className="col">
            <div className={classes.infomation} class="adjustment">
              <h4>HOURS</h4>
              <ul className="list-unstyled">
                <div className={classes.clinicInfo}>
                  <li>MONDAY 11AM - 7PM</li>
                  <li>TUESDAY 9AM - 7PM</li>
                  <li>WEDNESDAY 9AM - 7PM</li>
                  <li>THURSDAY 11AM - 7PM</li>
                  <li>FRIDAY 9AM - 6PM</li>
                  <li>SATURDAY 9AM - 3PM</li>
                  <li>SUNDAY 10AM - 2PM</li>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div class="container2">
          <hr />
          <div className="row">
            <p className="col-sm">
              <span className={classes.rights}>
                &copy;{year_format} Amplify Health and Wellness. All Rights
                Reserved.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
